import { Common } from '@stockbit/ui';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { LS_STREAM_TRENDING_TAB_DATE } from '../constants';

import streamWidget, { selectors } from '../slice';

const { IconWrapper, Iconmoon, Flex, Text } = Common;

const NORMAL_DATE_FORMAT = 'YYYY-MM-DD';

function DateSwitcher() {
  const dispatch = useDispatch();

  const { filterParams } = useSelector(selectors);

  const defaultDate = moment().format(NORMAL_DATE_FORMAT);
  const currentDate = filterParams.date || defaultDate;

  const handlePrevDate = () => {
    const prevDate = moment(currentDate)
      .subtract(1, 'days')
      .format(NORMAL_DATE_FORMAT);
    dispatch(
      // @ts-ignore
      streamWidget.actions.setFilterParam({
        date: prevDate,
      }),
    );
    localStorage.setItem(LS_STREAM_TRENDING_TAB_DATE, prevDate);
  };

  const handleNextDate = () => {
    const nextDate = moment(currentDate)
      .add(1, 'days')
      .format(NORMAL_DATE_FORMAT);
    dispatch(
      // @ts-ignore
      streamWidget.actions.setFilterParam({
        date: nextDate,
      }),
    );
    localStorage.setItem(LS_STREAM_TRENDING_TAB_DATE, nextDate);
  };

  const isShowNextDate =
    moment(currentDate).format(NORMAL_DATE_FORMAT) <
    moment().format(NORMAL_DATE_FORMAT);

  return (
    <Flex>
      <IconWrapper onClick={handlePrevDate}>
        <Iconmoon className="icon-toolbar_prev" size="16px" />
      </IconWrapper>
      <Text as="span" mx="12px">
        {moment(currentDate).format('dddd, MMMM DD YYYY')}
      </Text>
      {isShowNextDate && (
        <IconWrapper onClick={handleNextDate}>
          <Iconmoon className="icon-toolbar_next" size="16px" />
        </IconWrapper>
      )}
    </Flex>
  );
}

export default DateSwitcher;
